import merge from 'lodash/merge';

import { UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem } from '@common/product-card';
import { PDPGoodsGroup_goods_carousel_component_list as ProductCardItem } from '@domains/pdp-common';

export const isShowRanking = (type: string) => ['category_best_item_list'].includes(type);

export const getRanking = (showRanking: boolean, positon: number) => (showRanking ? positon + 1 : undefined);

export const convertProductCardItemsToUxGoodsCardItem = (item: ProductCardItem, ranking?: number) =>
  (ranking ? merge(item, { ranking }) : item) as UxGoodsCardItem;
